export const environment = {
  production: true,
  apiUrl: 'https://demo.apicanu.ovh',
  establishment : "demo"
  // apiUrl: 'https://luf.apicanu.ovh',
  // establishment : "luf"
};
